// moment.js 日期处理类库 see. http://momentjs.cn/
import moment from 'moment'

// moment设置为中文 XXX 先写死，之后需要国际化
moment.locale('zh-cn');

/******************* 全局过滤器 *********************************/


/**
 * 日期格式化过滤器
 * @param dateStr 所有可以被moment初始化的日期
 * @param pattern 转换格式
 * @returns {string}
 */
export function dateFormat(dateStr, pattern = 'YYYY-MM-DD') {
  if (dateStr === undefined || dateStr === null) {
    return "";
  }
  return moment(dateStr).format(pattern);
}

/**
 * 人肉UTC时区+8偏移 moment().utfOffset(8)没用？？？！！
 * @param {} dateStr 
 * @param {*} pattern 
 */
export function dateUTC8Format(dateStr, pattern = 'YYYY-MM-DD') {
  if (dateStr === undefined || dateStr === null) {
    return "";
  }
  let utcDate = moment(dateStr).toDate().getTime()+8*60*60*1000;
  return moment(utcDate).format(pattern);
}


